import React, { useState, useEffect, useRef } from "react";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import DeleteModal from "./Assets/DeleteModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const HeroImages = ({ isSidebarCollapsed }) => {
  const fileInputRef = useRef(null);
  const pcFileRef = useRef(null);
  const mobileFileRef = useRef(null);
  const [heroImages, setHeroImages] = useState([]);
  const [formData, setFormData] = useState({ image_name: "" });
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [preview, setPreview] = useState("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
    const [pcFile, setPcFile] = useState(null);
  const [mobileFile, setMobileFile] = useState(null);

  const [pcPreview, setPcPreview] = useState("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
  const [mobilePreview, setMobilePreview] = useState("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      
      const response = await fetch("https://backend.soapplants.com/api/v1/background/view", {
        method: "GET",
         headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
          },
      });
      if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }

      const result = await response.json();
      if (result.success) setHeroImages(result.data);
      else toast.error(result.message || "Failed to fetch hero images");
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch hero images");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.image_name.trim()) {
      toast.error("Image name is required!");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");

      const form = new FormData();
      form.append("image_name", formData.image_name);
      if (pcFile) form.append("image", pcFile);
      if (mobileFile) form.append("mobile_image", mobileFile);
      if (editId) form.append("id", editId);

      const url = editId
        ? "https://backend.soapplants.com/api/v1/background/edit"
        : "https://backend.soapplants.com/api/v1/background/add";

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // No 'Content-Type' → browser sets boundary
        },
        body: form,
      });

      const data = await response.json();

      if (data.success) {
        toast.success(data.message);
        setFormData({ image_name: "" });
        setEditId(null);
        setPcFile(null);
        setMobileFile(null);
        setPcPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
        setMobilePreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
        fetchData();
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          if (pcFileRef.current) {
            pcFileRef.current.value = "";
          }
          if (mobileFileRef.current) {
            mobileFileRef.current.value = "";
          }
      } else {
        toast.error(data.message || "Failed to save category");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Something went wrong!");
    }
  };


  const handleEdit = (id) => {
    const catToEdit = heroImages.find((c) => c.id === id);
    if (catToEdit) {
      setFormData({
        id: catToEdit.id,
        image_name: catToEdit.image_name,
      });
      setPcPreview(catToEdit.image_url || "https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
      setMobilePreview(catToEdit.mobile_image_url || "https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({ image_name: "" });
    setPcPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
    setMobilePreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");

    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`https://backend.soapplants.com/api/v1/background/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: itemToDelete }),
      });
      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        setHeroImages((prev) => prev.filter((cat) => cat.id !== itemToDelete));
      } else {
        toast.error(data.message || "Failed to delete hero image");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete hero image");
    } finally {
      setDeleteModalShow(false);
      setItemToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const loadPcFile = (e) => {
    const f = e.target.files[0];
    if (f) {
      setPcFile(f);
      setPcPreview(URL.createObjectURL(f));
    }
  };

  const loadMobileFile = (e) => {
    const f = e.target.files[0];
    if (f) {
      setMobileFile(f);
      setMobilePreview(URL.createObjectURL(f));
    }
  };

  return (
<div className="role-settings-container">
      <div className="bg-white p-[1vw] role-settings-form-container">
        <div className="text-[20px] font-bold border-b border-gray-300 pb-[2px] text-gray-600">
          <h1>{editId ? "Update Background Image" : "Upload Background Image"}</h1>
        </div>

        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Image Name *
            </label>

            <select
              name="image_name"
              value={formData.image_name}
              onChange={(e) =>
                setFormData({ ...formData, image_name: e.target.value })
              }
              className="shadow border rounded w-full py-2 px-3 text-gray-700"
              required
            >
              <option value="">Select Image Name</option>
              <option value="about-banner">About Banner</option>
              <option value="contact-banner">Contact Banner</option>
              <option value="product-banner">Product Banner</option>
              <option value="industrial-solution-banner">Industrial Solution Banner</option>
              <option value="work-banner">Work Banner</option>
            </select>
          </div>


          

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Upload Image For PC
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={loadPcFile} ref={pcFileRef}
              className="block w-full"
            />
            {pcPreview && (
              <img
                src={pcPreview}
                alt="Preview"
                className="mt-2 w-32 h-32 object-cover  rounded-lg shadow-sm"
              />
            )}
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Upload Image For Mobile (320 X 250)
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={loadMobileFile} ref={mobileFileRef}
              className="block w-full"
            />
            {mobilePreview && (
              <img
                src={mobilePreview}
                alt="Preview"
                className="mt-2 w-32 h-32 object-cover  rounded-lg shadow-sm"
              />
            )}
          </div>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={() => {
                  setFormData({ category_name: "", description: "" });
                  setEditId(null);
                  setFile(null);
                  setPcPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
                  setMobilePreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
                }}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
      <ul className="w-full role-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Background Image List</h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-5">
                        <th className="px-4 py-2 text-left">#</th>
                        <th className="px-4 py-2 text-left">Pc Image</th>
                        <th className="px-4 py-2 text-left">Mobile Image</th>
                        <th className="px-4 py-2 text-left">Name</th>
                        <th className="px-4 py-2 text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {heroImages.length > 0 ? (
                        heroImages.map((cat, index) => (
                          <tr className="grid grid-cols-5" key={cat.id}>
                            <td className="px-4 py-2">{index + 1}</td>
                            <td className="py-3 px-4 flex items-center gap-3">
                              <img
                                src={cat.image_url}
                                alt={cat.image_name}
                                className="h-16 w-16 object-cover "
                              />
                              
                            </td>
                            <td className="py-3 px-4 flex items-center gap-3">
                              
                              <img
                                src={cat.mobile_image_url	}
                                alt={cat.image_name}
                                className="h-16 w-16 object-cover "
                              />
                              
                            </td>

                            <td className="px-4 py-2 items-center"><div>
                                <div className="font-semibold text-gray-800">
                                  {cat.image_name || "—"}
                                </div>
                               
                              </div>
                            </td>
                            <td className="px-4 py-2">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(cat.id)}
                                  className="text-blue-500 hover:text-blue-700 text-[20px]"
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(cat.id)}
                                  className="text-red-500 hover:text-red-700 text-[20px]"
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="p-2 text-center">
                            No hero images found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>

      {deleteModalShow && (
        <DeleteModal
          itemName={
            heroImages.find((p) => p.id === itemToDelete)?.image_name ||
            "Image"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default HeroImages;
